import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { DynamicItemBaseComponent } from '@ups/xplat/dynamic-render';
import { FormatSettings } from '@progress/kendo-angular-dateinputs';
import { LogService } from '@ups/xplat/core';

@Component({
  selector: 'ups-dynamic-date',
  template: `
    <div class="dynamic-field-container" [class.selected]="config?.selected">
      <div
        class="dynamic-field form-input text-align"
        [formGroup]="group"
        [hidden]="!config?.isFormBuilder && config?.options?.hidden"
      >
        <ups-dynamic-helper-label
          [config]="config"
          [dynamicService]="dynamicService"
        ></ups-dynamic-helper-label>
        <div>
          @if (!config?.options?.showTimePicker) {
            <kendo-datepicker
              class="w-100"
              [attr.name]="config.formControlName"
              [format]="dateFormat"
              formatPlaceholder="formatPattern"
              (valueChange)="onDateChanged($event)"
              (open)="onOpen()"
              [placeholder]="config?.placeholder"
              [formControlName]="config.formControlName"
            ></kendo-datepicker>
          }
          @if (config?.options?.showTimePicker) {
            <kendo-datetimepicker
              class="w-100"
              [attr.name]="config.formControlName"
              [format]="dateFormat"
              formatPlaceholder="formatPattern"
              (valueChange)="onDateChanged($event)"
              (open)="onOpen()"
              [placeholder]="config?.placeholder"
              [formControlName]="config.formControlName"
            ></kendo-datetimepicker>
          }
        </div>
        @if (config?.isFormBuilder) {
          <div
            class="form-builder-mask"
            [class.hidden]="config?.options?.hidden"
          ></div>
        }
      </div>
      @if (config?.isFormBuilder) {
        <div class="form-builder-options">
          <i
            class="fas fa-times ml-3 cursor-pointer c-red"
            (click)="delete()"
          ></i>
          <!-- <i class="fas fa-bars ml-3 cursor-grab "></i> -->
        </div>
      }
    </div>
  `,
  // WI 35584: base-class marks cover async writes; ngDoCheck covers in-place config flags.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicDateComponent
  extends DynamicItemBaseComponent
  implements OnInit
{
  log = inject(LogService);

  // https://www.telerik.com/kendo-angular-ui/components/dateinputs/datetimepicker/formats/
  dateFormat: FormatSettings = {
    displayFormat: 'MM/dd/yyyy',
    inputFormat: 'MM/dd/yyyy',
  };

  ngOnInit() {
    super.ngOnInit();
    if (this.config.options?.showTimePicker) {
      this.dateFormat.displayFormat = 'MM/dd/yyyy - h:mm a';
      this.dateFormat.inputFormat = 'MM/dd/yyyy - h:mm a';
    }
  }

  onDateChanged(date) {
    this.log.debug('onDateChanged:', date);
    if (date) {
      this.updateValue(date);
    }
  }

  onOpen() {
    if (!this.group.get(this.config.formControlName).value) {
      // when date is not yet set, default to right now when opening
      this.updateValue(new Date());
    }
  }
}
